export const contractorDataPutCorrector = (violationData, data, creator) => {
  let correctData = violationData;
  correctData.removal_date = data.removalDate
    ? data.removalDate
    : violationData.removal_date;
  correctData.removal_description = data.removalDescription;
  correctData.removal_status = data.removalStatus
    ? data.removalStatus
    : violationData.removalStatus;
  correctData.creator = creator;
  return correctData;
};

export const contractorFieldsSetDisable = (initialData, contratorFields) => {
  if (initialData?.removalStatus) {
    for (let field of contratorFields) {
      if (
        field.variable === "removalDescription" ||
        field.variable === "removalDate"
      ) {
        field.disabled = true;
      }
    }
  } else {
    for (let field of contratorFields) {
      if (
        (field.variable === "removalDescription" ||
          field.variable === "removalDate") &&
        field.disabled
      ) {
        field.disabled = false;
      }
    }
  }
  return contratorFields;
};
